export default __webpack_public_path__ + "static/exideLifeInsurance-e0871c2ee8f75194920e2f8b8794a4d9.png";